"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedTextVO = void 0;
class LocalizedTextVO {
}
exports.LocalizedTextVO = LocalizedTextVO;
